import Contact_us from "../contact_us/contact_us";
import Services from "../services/services";
import Topbar from "../topbar/topbar";
import Footer from "../Footer/Footer";
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import img1 from "../../img/hcm1.jpg";
import FooterSec from "../footer_sec/footer_sec";
import ContactSection from "../contact/contact";
import PartnerVynHeader from "../partner_vyn_header/partner_vyn_header"
import Partnerbenefits from "../partner_benefits/partner_benefits";
import ReferralPartners from "../referral_partners/referral_partners";


export default function PartnerVyn({openPartnerModal}) {
  const solutionsAndServicesRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Scroll to the solutionsAndServicesRef element if it exists
    if (solutionsAndServicesRef.current) {
      solutionsAndServicesRef.current.scrollIntoView({ behavior: "auto" });
    }
  }, [location]);

  const handleGoBack = () => {
    window.history.back(); // Go back in the browser's history
  };
  return (
    <div id="partner_vyn">
      {/* <TopBar /> */}

      <Topbar />
      <PartnerVynHeader />
      <Partnerbenefits />
      <ReferralPartners openPartnerModal={openPartnerModal} />
      
      <FooterSec />
    </div>
  );
}
